import { useTheme } from '../contexts/ThemeContext';

function ChartSwitchDialog({ targetChartName, onKeepData, onUseSampleData, onCancel }) {
  const { resolved: theme } = useTheme();
  const ui = theme.ui || {};

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onCancel();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: ui.overlayBackdrop }}
      onClick={handleBackdropClick}
    >
      <div
        className="border flex flex-col ui-bg ui-border"
        style={{ width: 400, backgroundColor: ui.bg, borderColor: ui.border }}
      >
        {/* Header */}
        <div
          className="h-12 px-4 border-b flex items-center justify-between flex-shrink-0 ui-border"
          style={{ borderBottomColor: ui.border }}
        >
          <span className="text-sm font-medium" style={{ color: ui.text }}>
            Switch Chart Type
          </span>
          <button
            onClick={onCancel}
            className="text-sm w-7 h-7 flex items-center justify-center border border-transparent ui-hover"
            style={{ color: ui.text }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-4">
          <p className="text-sm mb-1" style={{ color: ui.text }}>
            You have imported data loaded.
          </p>
          <p className="text-xs mb-4" style={{ color: ui.textSecondary }}>
            Your data may not work well with <strong>{targetChartName}</strong>.
            You can keep it and remap columns automatically, or reset to sample data.
          </p>

          <div className="flex flex-col gap-2">
            <button
              onClick={onKeepData}
              className="w-full text-xs border py-2 font-medium ui-hover ui-border"
              style={{ borderColor: ui.border, color: ui.text }}
            >
              Keep Data & Remap
            </button>
            <button
              onClick={onUseSampleData}
              className="w-full text-xs border py-2 ui-hover ui-border"
              style={{ borderColor: ui.border, color: ui.text }}
            >
              Use Sample Data
            </button>
            <button
              onClick={onCancel}
              className="w-full text-xs py-2 ui-hover"
              style={{ color: ui.textSecondary }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChartSwitchDialog;
